import { Component, EventEmitter, Input, OnDestroy, OnChanges, OnInit, Output } from '@angular/core';
import { CityService } from '../../services/city.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import { QuoteOrderLine, SearchQuoteOrder, SearchQuoteOrderLineTypeProduct } from '../../models/models';

@Component({
    selector: 'quoteorderline-form',
    templateUrl: './quoteorderline-form.component.html',
    standalone: false
})
export class QuoteOrderLineForm implements OnDestroy, OnInit, OnChanges {
    @Input() quoteOrderLineID: number = 0;
    @Input() productID: number = 0;
    @Input() pageType: string = "";
    @Output() onRefresh = new EventEmitter<any>();

    public quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;
    public quoteOrderLineTypeList: SearchQuoteOrderLineTypeProduct[] = [];
    public searchQuoteOrder: SearchQuoteOrder = {} as SearchQuoteOrder;
    public isCRMAdmin: boolean = false;
    public isValidExternalTrackingLink: boolean = true;

    public recordLockAction: string = "";
    public recordLockSource: string = "";

    constructor(private cityService: CityService, private orderService: OrderService, private notificationService: NotificationService,
        private recordLockService: RecordLockService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.orderService.getSearchQuoteOrderLineTypeProductByProductID(this.productID).subscribe(result => {
            this.quoteOrderLineTypeList = result.resultCollection;
            this.quoteOrderLineTypeList = this.quoteOrderLineTypeList.sort((left, right): number => {
                if (left.abbrev < right.abbrev) return -1;
                if (left.abbrev > right.abbrev) return 1;
                return 0;
            });
        });

        this.isCRMAdmin = this.getIsCRMAdmin();
        this.initRecordLock();

        console.log("ngOnInit", this.quoteOrderLineID);
    }

    ngOnChanges() {
        this.utilService.isLoading = true;
        this.orderService.getQuoteOrderLineById(this.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            this.quoteOrderLine = result;

            this.orderService.getSearchQuoteOrderByID(this.quoteOrderLine.quoteOrderID).subscribe(result => {
                this.searchQuoteOrder = result.resultCollection[0];
            });

            console.log("ngOnChanges", this.quoteOrderLineID, this.quoteOrderLine);
        });
    }

    ngOnDestroy() {
        //this.recordLockService.resetRecordLock();
    }

    private getIsCRMAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('CRM Admin') > -1) return true;
        }

        return false;
    }

    public calcAmount() {
    //    if (!isNaN(this.quoteOrderLine.price) && !isNaN(this.quoteOrderLine.rate)) {
    //        this.quoteOrderLine.invoiceAmount = this.quoteOrderLine.quantity * this.quoteOrderLine.rate;
    //    }
    }

    public isValidUrl(url: string) {
        this.isValidExternalTrackingLink = this.utilService.isValidURL(url);
    }

    public canSave() {
        var isValid: boolean = true;
        if (!this.isValidExternalTrackingLink) {
            isValid = false;
        }
        return isValid;
    }

    public save() {
        this.recordLockAction = "save";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.quoteOrderLine.quoteOrderID, this.recordLockSource);
    }

    private allowSave() {
        this.utilService.isLoading = true;
        console.log("save", this.quoteOrderLine);
        this.orderService.saveQuoteOrderLine(this.quoteOrderLine).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.quoteOrderLineID > 0) {
                //this.getCustomers();
                this.cancel();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        this.quoteOrderLine = {} as QuoteOrderLine;
    }

    public cancel() {
        this.recordLockAction = "";
        this.onRefresh.emit();
    }

    private initRecordLock() {
        this.recordLockAction = "";
        this.recordLockSource = "Loads Grid";
        if (this.pageType == "orderentry") {
            //this.recordLockSource = "Order Entry: Loads Grid";
            this.recordLockSource = "Order Entry";
        }
        else if (this.pageType == "procurement") {
            this.recordLockSource = "Procurement";
        }
        else if (this.pageType == "tracking") {
            this.recordLockSource = "Tracking Dashboard";
        }

        this.recordLockService.hasRecordLockObserver.subscribe(result => {
            //console.log("order-form:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
            if (this.recordLockService.hasRecordLock) {
                if (this.recordLockAction == "save") {
                    this.allowSave();
                }
                this.recordLockAction = "";
            }
        });
    }
}
